import { graphql } from 'relay-runtime';

export const ATLASSIAN_ACCOUNT_USER_FRAGMENT = graphql`
  fragment AtlassianAccountUserFragment on AtlassianAccountUser {
    id
    email
    nickname
    name
    accountId
    accountStatus
    picture
  }
`;
